"use client";
import { useEffect } from "react";

export default function TidioScript() {
  useEffect(() => {
    const script = document.createElement("script");
    script.id = "tidio-script";
    script.src = "//code.tidio.co/ehbvru5sqchnohbngog2moybdfofyk4j.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // cleanup only if you want to remove the script on unmount
       document.getElementById("tidio-script")?.remove();
    };
  }, []);

  return null;
}